import "./OliveGroveToBottle.module.css";
import Cabecera from "@/reusable_sections/Header";
import IntroduccionEnVideo from "./sections/IntroduccionEnVideo";
import ProcesoDelOlivarALaBotella from "./sections/ProcesoDelOlivarALaBotella";
import QualityAndSustainability from "./sections/QualityAndSustainability";
import RequestInformationSection from "./sections/RequestInformationSection";
import PieDePagena from "@/reusable_sections/Footer";
export default function OliveGroveToBottlePage() {
  return <div>
      <Cabecera />
      <IntroduccionEnVideo />
      <ProcesoDelOlivarALaBotella />
      <QualityAndSustainability />
      <RequestInformationSection />
      <PieDePagena />
    </div>;
}